import type { State as S, Selector } from 'model/State';

export const selectHasSourceDownloads: Selector<object> = (state: S) =>
  state.mac.downloads.hasSourceDownloads || {};
